import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faCircle,
  faUser,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { loginActions } from "../store/userLogin-slice";
import { autoLogout } from "../utils/autoLogout";
import "./Search.css";
import baseUrl from "../url/baseUrl";
import { cartActions } from "../store/cart-slice";
import { searchActions } from "../store/Search-slice";

const Search = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.loginUser.isLogin);
  const username = useSelector((state) => state.loginUser.username);
  const cart = useSelector((state) => state.cart.items);

  // Mỗi khi component chứa giỏ hàng này được render sẽ nhận ngay được các mặt hàng trong cart => load trang không bị mất số trên biểu tượng giỏ hàng
  useEffect(() => {
    // Khi đã đăng nhập thì fetch số lượng items bình thường
    if (isLogin) {
      const getCart = async () => {
        try {
          const response = await fetch(baseUrl + "/get-cart", {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });

          if (response.status === 404) {
            throw new Error("Cannot show the cart");
          }

          if (response.status !== 200) {
            throw new Error("Not yet login or server error");
          }

          const data = await response.json();
          // cập nhật số lượng hàng trong giỏ vào redux store để hiển thị số lượng
          dispatch(cartActions.updateCartItems(data));
        } catch (err) {
          console.log(err);
        }
      };
      getCart();
      // Khi chưa đăng nhập thì cart sẽ lấy từ localstorage
    } else {
      const unLogCart = JSON.parse(localStorage.getItem("unLogCart")) || [];
      dispatch(cartActions.updateCartItems(unLogCart));
    }
  }, [isLogin, dispatch]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiryDate = localStorage.getItem("expiryDate");
    if (!token || !expiryDate) {
      return;
    }
    if (new Date(expiryDate) <= new Date()) {
      logoutHandler();
      return;
    }
    const remainingMilliseconds =
      new Date(expiryDate).getTime() - new Date().getTime();
    dispatch(
      loginActions.ON_LOGIN(JSON.parse(localStorage.getItem("currentUser")))
    );
    autoLogout(logoutHandler, remainingMilliseconds);
  }, [dispatch]);

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expiryDate");
    localStorage.setItem("currentUser", JSON.stringify({ isLogin: false }));
    dispatch(loginActions.ON_LOGOUT(localStorage.getItem("currentUser")));
    navigate("/login");
  };

  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(searchActions.updateSearchValue(value));
  };

  return (
    <>
      <section className="search container-fluid">
        <div className="row align-items-center text-center text-md-start">
          <div className="logo col-3 mb-1 mb-md-0 mt-sm-1">
            <img
              className="img-fluid mx-auto d-block"
              src="/images/logo.png"
              alt="meme Logo"
              style={{
                width: "100%",
                minWidth: "50px",
                maxWidth: "200px",
                margin: "0",
              }}
            />
          </div>
          <div className="col-6 mt-1 mt-md-0 p-1">
            <input
              className="form-control"
              style={{ height: "25px", fontSize: "0.8rem", padding: "0" }}
              type="text"
              placeholder="Tìm kiếm sản phẩm..."
              onChange={handleChange}
            />
          </div>
          <div className="col-3 d-flex justify-content-center justify-content-md-end gap-1 p-1 mt-1 mt-md-0 pe-md-3">
            <div className="text-center text-primary">
              <Link to={!isLogin ? "/register" : "/change-password"}>
                <FontAwesomeIcon
                  className={`cart_nav ${
                    isLogin ? "text-info" : "text-secondary"
                  }`}
                  icon={faUser}
                  mask={faCircle}
                  transform="shrink-8"
                />
              </Link>
              {isLogin && (
                <p
                  className="fst-italic mb-0 userInfo"
                  style={{ fontSize: "0.7rem" }}
                >
                  {username}
                </p>
              )}
            </div>

            <div className="cart">
              <Link
                to="/cart"
                className="position-relative text-decoration-none"
              >
                <FontAwesomeIcon
                  className="cart_nav text-success"
                  icon={faCartPlus}
                  mask={faCircle}
                  transform="shrink-8"
                />
                {cart.length !== 0 && (
                  <span className="NumberOrder position-absolute text-danger fw-bold">
                    {cart.length}
                  </span>
                )}
              </Link>
            </div>

            {isLogin && (
              <div
                className="text-center"
                role="button"
                onClick={logoutHandler}
              >
                <FontAwesomeIcon
                  className="nav_out text-danger"
                  icon={faRightFromBracket}
                />
                <p
                  className="text-danger userInfo"
                  style={{ fontSize: "0.7rem" }}
                >
                  Logout
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Search;
